// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1___30bd682bb7526b3fb81","cls2":"Comments-cls2___183f11f4f0fb5a90610 Comments-cls1___30bd682bb7526b3fb81"};